import React, { /* Component, */ useEffect, useState } from "react";
import { Tab } from "react-bootstrap";
import { /* connect, */ useDispatch, useSelector } from "react-redux";
// import { bindActionCreators } from "redux";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import moment from "moment";
import { getUserFarmList, switchFarm, farmSwitched } from "../../actions/farm";
import { SubNav } from "../layout/submenu";
import {
  planAnalyzeInfo,
  setSearchParams,
  unsubscribeAnalyzeKPI,
  clearAnalyzeData,
} from "../../actions/analyze";
import { setCurrentFarm } from "../../actions/farm";
import { clearMapData } from "../../actions/map";
import { clearCrewList } from "../../actions/crew";
import { clearEquipmentGroupList } from "../../actions/equipment-group";
import { clearOperatorList } from "../../actions/person";
import { clearEquipmentList } from "../../actions/equipment";
import { showOverlay } from "../../actions/toast";
import { getFarmOrganization } from "../../actions/organization";
import { Modal } from "../widgets";
import { searchWord, usePermission, isToday } from "../../helpers/common";
import { toCustomDate } from "../../helpers/moment-ex";
import { RANGE_TYPE_TODAY } from "../../constants";
import "../../../assets/scss/farm.scss";
import {
  getFarmInfo,
  removeLoadQueueSessionInputs,
} from "../../helpers/session";
import { deleteIndexData } from "../../helpers/indexedDBUtils";

const UserFarmSubList = () => {
  const searchInput = React.createRef();
  const initialState = {
    searchText: "",
    showSwitchFarmModal: false,
    selectedFarmId: null,
    farmId: null,
    switchFarmId: null,
    switchFarmName: null,
    rootUrl: "",
  };

  let userFarmList = useSelector((state) => state.farm.userFarmList);
  const timezoneIdentifier = useSelector(
    (state) => state.farm.currentFarm.timezone_identifier
  );
  const { range } = useSelector((state) => state.analyze.searchParams);
  const [state, setState] = useState(initialState);

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const url = { pathname: `${location.pathname}`, search: location.search };
  const { searchText, showSwitchFarmModal, farmId, rootUrl } = state;
  const allow = usePermission();
  const isAllowCreate = allow("farm", "create") ? isToday(range) : false;
  const isAllowView = allow("farm", "view") ? isToday(range) : false;
  const archivedFarmList = userFarmList.filter((farm) => farm.status_id === 5);
  userFarmList = userFarmList.filter((farm) => farm.status_id === 1);

  if (searchText && searchText.trim().length > 0)
    userFarmList = userFarmList.filter((e) =>
      searchWord(e.farm_name, searchText)
    );

  const farmTitle = `Farms ${userFarmList.length > 0 ? `(${userFarmList.length})` : ""
    }`;

  useEffect(() => {
    searchInput.current.focus();
    const farmId = getFarmInfo().farm_uuid;
    const newState = {
      ...state, farmId, rootUrl: `/home/farm/${farmId}/farm`
    }
    setState(newState);
    dispatch(planAnalyzeInfo(farmId));
    dispatch(getUserFarmList());
  }, []);


  const handleSearchBox = (searchText) => {
    const newState = { ...state, searchText }
    setState(newState);
  };

  const handleConfirm = () => {
    const farmId = state.switchFarmId;
    const newState = { ...state, showSwitchFarmModal: false };
    setState(newState);

    dispatch(
      switchFarm(farmId, () => {
        const farmInfo = userFarmList.filter((e) => e.farm_uuid === farmId);
        if (farmInfo.length > 0) {
          dispatch(showOverlay({ text: "Switching..." }));
          dispatch(clearMapData());
          removeLoadQueueSessionInputs();
          deleteIndexData('geoRegionList');

          // Reset date selection
          const now = moment.utc().tz(timezoneIdentifier);
          const start = moment(now).startOf("days");
          const end = moment(now).endOf("days");
          const dateObj = toCustomDate(start, end);
          const searchParams = {
            range: RANGE_TYPE_TODAY,
            customRange: RANGE_TYPE_TODAY,
            ...(dateObj && { custom: dateObj, absolute: dateObj }),
          };
          dispatch(setSearchParams({ ...searchParams, enable: false }));

          // Set the current farm detail
          dispatch(setCurrentFarm(farmInfo[0]));
          dispatch(getFarmOrganization(farmId));
          const newState = { ...state, farmId, showSwitchFarmModal: false };
          setState(newState);

          history.push(`/home/farm/${farmId}/map/switchfarm`);
          dispatch(setSearchParams({ ...searchParams, enable: true }));
          dispatch(farmSwitched());
          dispatch(unsubscribeAnalyzeKPI());
          dispatch(clearAnalyzeData());
          dispatch(planAnalyzeInfo(farmId));
          dispatch(clearCrewList());
          dispatch(clearEquipmentGroupList());
          dispatch(clearOperatorList());
          dispatch(clearEquipmentList());
        }
      })
    );
  };

  const handleFarmSwicthModalShow = (id, farmName) => {
    const newState = {
      ...state,
      showSwitchFarmModal: !(farmId === id),
      switchFarmId: id,
      switchFarmName: farmName,
    };
    setState(newState);
  };

  const handleFarmSwicthModalClose = () => {
    const newState = { ...state, showSwitchFarmModal: false }
    setState(newState);
  };


  return (
    <SubNav>
      <SubNav.Subheader>
        <div className="title-container">
          <aside className="section-title">
            {isAllowView ? (
              <NavLink to={`${rootUrl}/list`}>
                {farmTitle}
                <i className="fa fa-angle-right section-right-arrow"></i>
              </NavLink>
            ) : (
              farmTitle
            )}
          </aside>
          {isAllowCreate && (
            <aside className="section-icon-container">
              <NavLink
                className="m-0 p-0 btn-kanban-eg"
                to={`${rootUrl}/list`}
                title="Manage Farm"
              >
                <i className="fa fa-plus-circle" aria-hidden="true" />
              </NavLink>
            </aside>
          )}
        </div>
      </SubNav.Subheader>

      <SubNav.SearchBox
        ref={searchInput}
        placeholder="Farm name"
        value={searchText}
        onChange={(e) => handleSearchBox(e.target.value)}
        onClear={() => handleSearchBox("")}
      />

      <Tab.Container defaultActiveKey={-1}>
        <Tab.Content>
          <Tab.Pane eventKey={-1} className="scroll-bar-2 ">
            {userFarmList.length === 0 && <SubNav.NotFound />}
            {userFarmList.length > 0 && (
              <SubNav.List>
                {userFarmList.map((e, index) => (
                  <SubNav.Item
                    key={index}
                    selected={e.farm_uuid === farmId}
                    className={`highlight py-1 ${e.farm_uuid === farmId &&
                      "form-unpoint"}`}
                  >
                    <SubNav.Card
                      onClick={() => handleFarmSwicthModalShow(
                        e.farm_uuid,
                        e.farm_name
                      )}
                    >
                      <SubNav.Link to={url} bullet={true}>
                        {e.farm_name}
                      </SubNav.Link>
                    </SubNav.Card>
                  </SubNav.Item>
                ))}
              </SubNav.List>
            )}
            {archivedFarmList.length > 0 && (
              <SubNav.Divider name={"Archived"} className="archive" />
            )}
            {archivedFarmList.length > 0 && (
              <SubNav.List className="mt-2">
                {archivedFarmList.map((e, index) => (
                  <SubNav.Item
                    key={index}
                    selected={e.farm_uuid === farmId}
                    className="highlight py-1"
                  >
                    <SubNav.Card
                      onClick={() => handleFarmSwicthModalShow(
                        e.farm_uuid,
                        e.farm_name
                      )}
                    >
                      <SubNav.Link to={url} bullet={true}>
                        {e.farm_name}
                      </SubNav.Link>
                    </SubNav.Card>
                  </SubNav.Item>
                ))}
              </SubNav.List>
            )}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
      <Modal.Confirm
        isOpen={showSwitchFarmModal}
        onConfirm={handleConfirm}
        iconClassName="fa fa-angle-double-right"
        title="Switch Farm"
        body={`Are you sure you want to switch the farm?`}
        variant="info"
        confirmButton={{ variant: "info" }}
        onHide={handleFarmSwicthModalClose}
      />
    </SubNav>
  );
};

export default UserFarmSubList;
